export default __webpack_public_path__ + "static/media/1287.751e9cda.png";